import React from "react";
import clsx from "clsx";
import { Check } from "lucide-react";

import styles from "./checkbox.module.css";

export interface CheckboxProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function Checkbox({
  id,
  label,
  checked,
  onChange,
  disabled = false,
}: CheckboxProps) {
  return (
    <label
      className={clsx(styles.root, disabled && styles.rootDisabled)}
      htmlFor={id}
    >
      <span className={styles.control}>
        <input
          id={id}
          type="checkbox"
          className={styles.nativeInput}
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span
          className={clsx(styles.box, checked && styles.boxChecked)}
          aria-hidden
        >
          {checked ? (
            <Check className={styles.icon} size={12} strokeWidth={3} aria-hidden />
          ) : null}
        </span>
      </span>
      <span className={clsx("body-sm", "text-muted", styles.label)}>{label}</span>
    </label>
  );
}
